import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore, useRegistrationStore, useTeamStore } from '@/stores/index';
import { storeToRefs } from 'pinia';

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [],
  linkActiveClass: 'active',
});

const getPathByName = (name: string) => {
  const route = router.getRoutes().find((route) => route.name === name);
  return route ? route.path : '';
};

router.beforeEach(async (to, from, next) => {
  const routeExists = router.resolve(to).matched.length > 0;
  if (!routeExists) {
    return next({ name: 'NotFound' });
  }
  const auth = useAuthStore();
  const team = useTeamStore();
  const registrationStore = useRegistrationStore();
  const { isAdmin, returnUrl } = storeToRefs(auth);
  const { belongs } = storeToRefs(team);

  if (auth.isLoggedIn && auth.role === 'Team') {
    await team.getMyTeamQuery.suspense();
    await registrationStore.getMyRegistration.suspense();
  }
  // Check if route requires authentication based on 'guest' meta
  const authRequired = !(to.meta.guest === true);

  let nextTab = null;
  if (to.path == getPathByName('TeamsDisplayView')) {
    auth.showNav = false;
    return next();
  } else {
    auth.showNav = true;
  }
  // Redirect to login page if not logged in and trying to access a restricted page
  if ((authRequired || to.path == '/') && !auth.isLoggedIn) {
    returnUrl.value = to.fullPath;
    to.path = getPathByName('Login');
    router.push(to.path);
    nextTab = null;
  } else if (
    to.path !== getPathByName('ForceReset') &&
    authRequired &&
    auth.isLoggedIn &&
    auth.me?.force_reset
  ) {
    nextTab = 'ForceReset';
  } else if (
    isAdmin.value &&
    !to.path.startsWith('/admin') &&
    to.path != '/account/my-profile' &&
    to.path !== getPathByName('ForceReset')
  ) {
    nextTab = 'Admin';
  } else if (
    auth.isLoggedIn &&
    auth.isUser &&
    !auth.me?.force_reset &&
    auth.me?.notUpToDate &&
    to.path != getPathByName('MyProfile')
  ) {
    to.path = getPathByName('MyProfile');
    router.push(to.path);
    nextTab = null;
  }

  if (!auth.me?.force_reset && !auth.me?.notUpToDate) {
    if (auth.isLoggedIn && auth.isUser && !belongs.value && to.path != getPathByName('TeamLess')) {
      to.path = getPathByName('TeamLess');
      router.push(to.path);
      nextTab = null;
    } else if (belongs.value && auth.isUser && to.path == getPathByName('TeamLess')) {
      to.path = getPathByName('Home');
      router.push(to.path);
      nextTab = null;
    }
  }
  if (nextTab) {
    return next({ name: nextTab, query: to.query });
  } else {
    next();
  }
});
